<template>
  <div class="topFrame">
    <div class="topFrame__inner">
      <div class="topFrame_headerImage"><img alt="Casamassa logo" src="../assets/logo.png"></div>
      <div class="topFrame__subline">Webentwickler aus Köln</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopFrame',
  props: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .topFrame {
    position: relative;
    height: 50%;
    width: 100%;
    background-color: #293133;

    &__inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &__subline {
      color: #fff;
    }

    &_headerImage {

    }
  }
</style>
